var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnityPages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "pages") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.868 6.984l-3.83-1.302-0.193 1.186 3.667 1.223c0.355 0.16 0.57 0.518 0.355 0.893l-6.373 19.816c0 0.215-0.16 0.375-0.375 0.375h-0.518l-7.695-2.285c-2.32-0.375-4.033-0.66-5.176-0.82-0.219-0.050-0.392-0.087-0.55-0.12l-0.893-0.146c-0.292-0.032-0.629-0.056-1.218-0.109l15.156 4.586c0 0 1.045 0.228 1.465 0 0.375-0.215 0.75-0.535 0.91-1.105l6.373-19.816c0.358-1.108-0.213-2.018-1.107-2.375z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.122 27.906c0.73 0.162 1.48-0.373 1.48-1.105l3.243-19.932-0.028-0.009 0.213-1.18 0.008 0.003 0.029-0.178c0.16-0.52-0.359-1.27-1.107-1.27l-4.732-0.891v-0.537c0-0.732-0.535-1.088-1.266-1.088h-0.16l-12.748 0.891c-0.75 0-1.268 0.734-1.107 1.27l1.465 20.762c0 0.73 0.535 1.090 1.266 1.090h0.162l0.45 0.074c0.279 0.030 0.526 0.070 0.893 0.146l11.94 1.956zM4.053 3.717c0 0 0-0.213 0.16-0.213l12.748-0.895c0 0 0.195 0 0.195 0.197l1.445 20.729v0.195l-12.926 0.91-1.623-20.924z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.587 5.877l-4.176 0.375c-0.359 0-0.572 0.357-0.572 0.732 0.213 0.355 0.375 0.535 0.75 0.535l4.195-0.375c0.375 0 0.535-0.32 0.535-0.695s-0.375-0.572-0.733-0.572z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.159 8.609l-2.373 0.213c-0.375 0-0.572 0.322-0.572 0.697 0.197 0.356 0.375 0.57 0.732 0.57l2.375-0.215c0.355 0 0.535-0.355 0.535-0.73-0-0.322-0.34-0.535-0.697-0.535z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnityPages);
export default __webpack_public_path__ + "static/media/unity_pages.52dfafb11673d3ba1b1b167aa425c758.svg";
export { ForwardRef as ReactComponent };